define(function (require) {
    "use strict";

    var LE = require("app");
    var DateUtility = require("utils/DateUtility");

    var TicketListComparators = [];

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketListComparators = [

        ];
    });

    return TicketListComparators;
});
